
import React from 'react';
import { LuxuryChatLoadingState } from './LuxuryChatLoadingState';

interface ChatLoadingStateProps {
  username?: string;
  onRetry: () => void;
  loadingStage?: 'connecting' | 'loading-messages' | 'finalizing';
}

export const ChatLoadingState: React.FC<ChatLoadingStateProps> = ({ 
  username, 
  onRetry,
  loadingStage 
}) => {
  return (
    <LuxuryChatLoadingState 
      username={username}
      onRetry={onRetry}
      loadingStage={loadingStage}
    />
  );
};
